export type Breadcrumb = {
  at: string;
  category: 'click' | 'navigation' | 'submit' | 'manual';
  message: string;
  data?: Record<string, string>;
};

const RING_CAPACITY = 50;
const ring: Breadcrumb[] = [];

function push(b: Breadcrumb) {
  ring.push(b);
  while (ring.length > RING_CAPACITY) ring.shift();
}

export function addManualBreadcrumb(message: string, data?: Record<string, string>) {
  push({ at: new Date().toISOString(), category: 'manual', message, data });
}

export function getBreadcrumbsSnapshot(): Breadcrumb[] {
  return ring.slice();
}

let installed = false;

export function installBreadcrumbListeners() {
  if (installed) return;
  installed = true;

  document.addEventListener(
    'click',
    (evt) => {
      try {
        const target = evt.target as HTMLElement | null;
        if (!target) return;
        const label = describeElement(target);
        push({
          at: new Date().toISOString(),
          category: 'click',
          message: `click ${label}`,
        });
      } catch {
      }
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'submit',
    (evt) => {
      try {
        const target = evt.target as HTMLFormElement | null;
        const action = target?.getAttribute('action') || target?.id || '<form>';
        push({
          at: new Date().toISOString(),
          category: 'submit',
          message: `submit ${action}`,
        });
      } catch {
      }
    },
    { capture: true, passive: true }
  );

  window.addEventListener('popstate', () => {
    push({
      at: new Date().toISOString(),
      category: 'navigation',
      message: `nav ${window.location.pathname}${window.location.search}`,
    });
  });

  patchHistoryMethod('pushState');
  patchHistoryMethod('replaceState');
}

function patchHistoryMethod(name: 'pushState' | 'replaceState') {
  const original = window.history[name];
  window.history[name] = function patched(this: History, ...args: Parameters<History['pushState']>) {
    const result = original.apply(this, args);
    try {
      ring.push({
        at: new Date().toISOString(),
        category: 'navigation',
        message: `nav ${window.location.pathname}${window.location.search}`,
      });
      while (ring.length > RING_CAPACITY) ring.shift();
    } catch {
    }
    return result;
  } as typeof original;
}

function describeElement(el: HTMLElement): string {
  const tag = el.tagName.toLowerCase();
  const id = el.id ? `#${el.id}` : '';
  const cls = el.className && typeof el.className === 'string' ? `.${el.className.split(/\s+/).slice(0, 2).join('.')}` : '';
  const text = (el.textContent || '').trim().slice(0, 30);
  return `${tag}${id}${cls}${text ? ` "${text}"` : ''}`;
}
